import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as actions from '../../features/schedule/redux/actions';
import CustomLoader from '../common/CustomLoader';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../common/formElements/CustomSelect';
import { prepareFieldOptions, prepareUserEmailFieldOptions } from './utils';

export class EmailTaskSchedule extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    timeOptions: [
      { label: '10 min before', value: '10 min' },
      { label: '30 min before', value: '30 min' },
      { label: '1 hr before', value: '1 hr' },
      { label: '1 day before', value: '1 day' },
    ],
  };

  componentDidMount() {
    const { projectId, actions, version } = this.props;
    actions.loadCollectionInSchedule({ projectId, version });
    actions.loadEmailTemplates({ projectId, version });
  }

  scheduleSchema = () => {
    const { taskDetail } = this.props;
    if (!taskDetail || !taskDetail.settings) {
      return {
        emailTemplate: '',
        collectionName: '',
        collectionFilter: '',
        collectionField: '',
        time: '',
        emailField: '',
        emailServicePlugin: '',
      };
    }
    return {
      emailTemplate: taskDetail.settings.emailTemplate,
      collectionName: taskDetail.settings.collectionName,
      collectionFilter: taskDetail.settings.collectionFilter,
      collectionField: taskDetail.settings.collectionField,
      time: taskDetail.settings.time,
      emailField: taskDetail.settings.emailField,
      emailServicePlugin: taskDetail.settings.emailServicePlugin,
    };
  };

  scheduleSchemaValidation = () => {
    let validationSchema = {
      emailTemplate: Yup.string().required("Email Template can't be blank."),
      collectionName: Yup.string().required("Collection Name can't be blank."),
      collectionFilter: Yup.string().required("Collection Filter can't be blank."),
      // collectionField: Yup.string().required("Collection Field can't be blank."),
      // time: Yup.string().required("Time can't be blank."),
      emailField: Yup.string().required("Email can't be blank."),
      emailServicePlugin: Yup.string().required("Email Service Plugin can't be blank."),
    };
    return Yup.object().shape(validationSchema);
  };

  handleSubmit = (values) => {
    this.props.handleSubmit(values);
  };

  renderFilter = (values, setFieldValue, setFieldTouched) => {
    const collectionUuid = values.collectionName;
    if (!collectionUuid) {
      return '';
    }
    const { schedule } = this.props;
    const { collections } = schedule;
    if (!collections || collections.length === 0) {
      return '';
    }

    const selCollection = collections.find((collection) => collection.uuid === collectionUuid);
    if (!selCollection) {
      return '';
    }

    const { fields, finders } = selCollection;
    const fieldOptions = prepareFieldOptions(fields, collections);
    const finderOptions = finders.map((finder) => ({ label: finder.name, value: finder.uuid }));
    return (
      <>
        <div className="col-md-6 col-lg-6 col-sm-6">
          <CustomInputWithIcon icon="select" required={true} title="Collection Filter">
            <CustomSelect
              name="collectionFilter"
              isMulti={false}
              options={finderOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Collection Filter"
              value={values.collectionFilter}
            />
            <p className="text-danger">
              <ErrorMessage name="collectionFilter" />
            </p>
          </CustomInputWithIcon>
        </div>
        {/* <div className="col-md-6 col-lg-6 col-sm-6">
          <CustomInputWithIcon icon="text" required={true} title="Collection Field">
            <CustomSelect
              name="collectionField"
              isMulti={false}
              options={fieldOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Date Field to Comapre"
              value={values.collectionField}
            />
            <p className="text-danger">
              <ErrorMessage name="collectionField" />
            </p>
          </CustomInputWithIcon>
        </div> */}
        {/* <div className="col-md-6 col-lg-6 col-sm-6">
          <CustomInputWithIcon icon="text" required={true} title="Send Mail Before">
            <CustomSelect
              name="time"
              isMulti={false}
              options={this.state.timeOptions}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Send Mail Before"
              value={values.time}
            />
            <p className="text-danger">
              <ErrorMessage name="time" />
            </p>
          </CustomInputWithIcon>
        </div> */}
      </>
    );
  };

  renderEmailField = (values, setFieldValue, setFieldTouched) => {
    const collectionUuid = values.collectionName;
    if (!collectionUuid) {
      return '';
    }
    const { schedule } = this.props;
    const { collections } = schedule;
    if (!collections || collections.length === 0) {
      return '';
    }

    const selCollection = collections.find((collection) => collection.uuid === collectionUuid);
    if (!selCollection) {
      return '';
    }

    const { fields, finders } = selCollection;
    const fieldOptions = prepareUserEmailFieldOptions(fields, collections);

    return (
      <div className="col-md-6 col-lg-6 col-sm-6">
        <CustomInputWithIcon icon="select" required={true} title="User Email">
          <CustomSelect
            name="emailField"
            isMulti={false}
            options={fieldOptions}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder="User Email"
            value={values.emailField}
          />
          <p className="text-danger">
            <ErrorMessage name="emailField" />
          </p>
        </CustomInputWithIcon>
      </div>
    );
  };

  handleCancel = () => {
    const { projectId, version, history } = this.props;
    history.push(`/2.0/schedule/${version}/v/${projectId}/`);
  };

  render() {
    const { schedule, installedPlugins } = this.props;
    const {
      loadEmailTemplatesPending,
      loadCollectionInSchedulePending,
      collections,
      emailTemplates,
    } = schedule;
    const emailTemplateOptions = emailTemplates.map((template) => ({
      label: template.name,
      value: template.uuid,
    }));

    const collectionOptions = collections.map((collection) => ({
      label: collection.collectionTitle,
      value: collection.uuid,
    }));

    const getEmailServicePluginOptions = () => {
      let options = [{ value: '', label: '-Select One-' }];
      if (installedPlugins.some((plugin) => plugin.code === 'AWS_SES')) {
        options.push({ value: 'AWS_SES', label: 'AWS SES' });
      }
      if (installedPlugins.some((plugin) => plugin.code === 'SENDGRID')) {
        options.push({ value: 'SENDGRID', label: 'SendGrid' });
      }
      if (installedPlugins.some((plugin) => plugin.code === 'RESEND')) {
        options.push({ value: 'RESEND', label: 'Resend' });
      }
      return options;
    };

    return (
      <div className="schedule-email-task-schedule">
        {(loadEmailTemplatesPending || loadCollectionInSchedulePending) && (
          <div className="text-center">
            <CustomLoader
              loading={loadEmailTemplatesPending || loadCollectionInSchedulePending}
              size="20px"
              color="#303453"
            />
          </div>
        )}
        <Formik
          enableReinitialize={true}
          initialValues={this.scheduleSchema()}
          validationSchema={this.scheduleSchemaValidation()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
            <Form className="form-horizontal">
              <div className="row">
                <div className="col-12">
                  <h6>Step 1: Choose Email Service to use</h6>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <CustomInputWithIcon icon="select" required={true} title="Email Template">
                    <CustomSelect
                      name="emailServicePlugin"
                      isMulti={false}
                      options={getEmailServicePluginOptions()}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="Email Service Plugin"
                      value={values.emailServicePlugin}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="emailTemplate" />
                    </p>
                  </CustomInputWithIcon>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h6>Step 2: Choose Email Template to send</h6>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <CustomInputWithIcon icon="select" required={true} title="Email Template">
                    <CustomSelect
                      name="emailTemplate"
                      isMulti={false}
                      options={emailTemplateOptions}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="Email Template"
                      value={values.emailTemplate}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="emailTemplate" />
                    </p>
                  </CustomInputWithIcon>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <h6>Step 3: Configure Collection</h6>
                </div>
                <div className="col-md-6 col-lg-6 col-sm-6">
                  <CustomInputWithIcon icon="select" required={true} title="Email Template">
                    <CustomSelect
                      name="collectionName"
                      isMulti={false}
                      options={collectionOptions}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="Collection"
                      value={values.collectionName}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="collectionName" />
                    </p>
                  </CustomInputWithIcon>
                </div>
                {this.renderFilter(values, setFieldValue, setFieldTouched)}
              </div>

              <div className="row">
                <div className="col-12">
                  <h6>Step 4: Send Mail To</h6>
                </div>

                {this.renderEmailField(values, setFieldValue, setFieldTouched)}
              </div>

              <div className="row">
                <div className="col-md-6  ">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-md"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    // disabled={isSubmitting || createSchedulePending}
                  >
                    Schedule
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailTaskSchedule);
